import { CheckCircle2, Clock } from 'lucide-react';
import type { AppointmentFormState } from '../useAppointmentForm';

export default function ConfirmView({ state }: { state: AppointmentFormState }) {
  const { config, bookingResult, selectedService, selectedConsultant, selectedStore, selectedSlot, reset } = state;
  if (!config || !bookingResult) return null;

  const isConfirmed = bookingResult.status === 'confirmed';
  const message = isConfirmed
    ? config.privacy.successMessage || 'Prenotazione confermata!'
    : config.privacy.pendingMessage || 'Richiesta inviata, in attesa di approvazione';

  const dt = selectedSlot ? new Date(selectedSlot.start) : null;

  return (
    <div className="aw-confirm">
      <div className="aw-confirm-icon">
        {isConfirmed ? <CheckCircle2 size={32} /> : <Clock size={32} />}
      </div>
      <h3>{message}</h3>
      <p>Riceverai una email di conferma all'indirizzo indicato.</p>

      {selectedService && dt && (
        <div className="aw-summary" style={{ maxWidth: 400, margin: '16px auto' }}>
          <div><span>Servizio</span><strong>{selectedService.name}</strong></div>
          {selectedConsultant && (
            <div><span>Consulente</span><strong>{selectedConsultant.fullName}</strong></div>
          )}
          {selectedStore && (
            <div><span>Sede</span><strong>{selectedStore.city ? `${selectedStore.name} — ${selectedStore.city}` : selectedStore.name}</strong></div>
          )}
          <div>
            <span>Data</span>
            <strong>{dt.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })}</strong>
          </div>
          <div>
            <span>Ora</span>
            <strong>{dt.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}</strong>
          </div>
        </div>
      )}

      <button type="button" className="aw-btn aw-btn-ghost" onClick={reset}>
        Prenota un altro appuntamento
      </button>
    </div>
  );
}
